export default __webpack_public_path__ + "static/media/category_switch.9368da07.svg";